import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PagesEventService, Url } from "src/app/common";
import { User, UserAuth } from "src/app/common/user-auth";
import { Ticket } from "../models/ticket.model";
import { TicketService } from "../services/ticket.service";
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-screenshot-ticket',
  templateUrl: '../views/screenshot-ticket.component.html',
  styleUrls: ['../styles/style.css']
})
export class ScreenshotTicketComponent implements OnInit {
  zoneSelect:any;
  overlay:any; outline:any;
  element:any; dimensions:any;
  screenshotMode = false;
  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event:any) {
    this. mouseupScreenshot();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event:any) {
    this.mousemoveScreenshot(event);
  }

  userAuth: User = UserAuth.get();
  ticket = new Ticket();
  url = Url;
  onSubmit=null;
  priority = ['low', 'medium', 'high'];
  ticketsGroups = [];
  ticketsCategory = [];
  group_id;
  ticketCategory;

  imageEditor = {
    show: false,
    top: 20,
    file: null,
    fileName: null,
    readUrl: null,
    saveUrl: null,
    width: window.innerWidth - 100,
    height: window.innerHeight,
    description: null,
  };

  constructor(private pagesEventService: PagesEventService,
              private router: Router,
              public ticketService: TicketService) {
  }

  ngOnInit(): void {
    this.ticket.user_id = this.userAuth.id;
    this.ticket.status = 'New';
    this.getAllGroups();
    this.getTicketCategories();
  }

  getTicketCategories() {
    this.ticketService.getTicketsCategory({}).subscribe((response) => {
      this.ticketsCategory = response.TicketsCategory;
    });
  }

  getAllGroups() {
    this.ticketService.getAllTicketsGroups().subscribe((response) => {
      this.ticketsGroups = response.TicketsGroup;
      this.ticket.tickets_group_id = response.TicketsGroup[0].id;
    });
  }

  openEditor(file, fileName) {
    this.imageEditor.file = file;
    this.imageEditor.description = file.description;
    this.imageEditor.fileName = fileName;
    this.imageEditor.readUrl = `/image/${fileName}`;
    this.imageEditor.saveUrl = `/tickets/files`;
    this.imageEditor.show = true;
  }

  onEditorClosed(event) {
    if(event.file != null) {
      this.ticket.screenShots.filter(shoot => shoot.fileName == event.file.originalName)[0].fileName = event.file.fileName;
      this.ticket.files.filter(shoot => shoot.fileName == event.file.originalName)[0].fileName = event.file.fileName;
    }
    this.imageEditor.show=false;
  }

  deleteFile(index) {
    this.ticket.files.splice(index,1);
    this.ticket.screenShots.splice(index,1);
  }

  submit(value) {
    this.onSubmit = true;
    this.ticketService.createTicket(Ticket.prepare(this.ticket)).subscribe((response) => {
      this.ticket  = new Ticket();
      this.onSubmit = false;
    });
  }

  selectedGroup() {
    this.ticket.tickets_group_id = this.group_id.id;
  }

  selectedCategory() {
    this.ticket.ticket_category = this.ticketCategory.name;
    this.ticket.ticket_category_id = this.ticketCategory.id;
  }

  reportBug() {
    this.screenshotMode = !this.screenshotMode;
  }

  mouseupScreenshot() {
    if(this.screenshotMode) {
      html2canvas(this.element).then(canvas => {
        canvas.toBlob((result) => {
          var file = new File([result], this.getRandomFileName()+".png");
          this.saveFile(file);
        });
      });
    }
  }

  getRandomFileName() {
    var timestamp = new Date().toISOString().replace(/[-:.]/g,"");
    var random = ("" + Math.random()).substring(2, 8);
    var random_number = timestamp+random;
    return random_number;
  }

  saveFile(file) {
    this.ticketService.saveFile(file).subscribe((response) => {
      this.ticket.files = this.ticket.files || [];
      this.screenshotMode = false;
      this.ticket.screenShots.push({file:file,fileName:response.File.fileName});
      this.ticket.files.push(response.File);
    });
  }

  mousemoveScreenshot(e) {
    if(this.screenshotMode) {
      if (this.element !== e.target) {
        this.element = e.target;
        this.zoneSelect = document.getElementById("zoneSelect");
        this.zoneSelect.style.width = "0px";
        let el = this.element.getBoundingClientRect();
        this.zoneSelect.style.top = el.top + "px";
        this.zoneSelect.style.left = el.left + "px";
        this.zoneSelect.style.width = el.width + "px";
        this.zoneSelect.style.height =  el.height + "px";
      }
    }
    else{
      this.zoneSelect = document.getElementById("zoneSelect");
      this.zoneSelect.style.top = "0px";
      this.zoneSelect.style.left = "0px";
      this.zoneSelect.style.width =  "0px";
      this.zoneSelect.style.height =  "0px";
    }
  }

}
